<ng-container *cftI18n="let t">
  @if (option$ | async; as options) {
    @if (!options.isLoading) {
      @if (options.options?.length) {
        <ul role="listbox" tabindex="-1">
          @for (option of options.options; track option) {
            <li (click)="selectValue(option)" [attr.data-testid]="'filter-' + option.name" role="option">
              <button cft-nav-list-item class="filter__option" tabindex="0">
                {{ option.name }}
              </button>
            </li>
          }
        </ul>
      } @else {
        @if (!noOptionsMessage) {
          <div (click)="selectEmpty()" class="filter__option__no-result">
            {{ t('filter.noResult') }}
          </div>
        } @else {
          <div (click)="selectEmpty()" class="filter__option__initial-message">{{ noOptionsMessage }}</div>
        }
      }
    } @else {
      <div class="filter_option__spinner">
        <cft-spinner></cft-spinner>
      </div>
    }
  } @else {
    <div class="filter_option__spinner">
      <cft-spinner></cft-spinner>
    </div>
  }
</ng-container>
